import React from 'react';
import PropTypes from 'prop-types';
import { domOnlyProps, FieldBlock, TextBlock } from 'cccisd-redux-form-helpers';
import style from './style.css';

export default class AddressBlock extends React.Component {
    static propTypes = {
        address: PropTypes.object,
        city: PropTypes.object,
        state: PropTypes.object,
        zip: PropTypes.object,
    };

    render() {
        const { address, city, state, zip } = this.props;
        return (
            <div>
                <TextBlock field={address} label="Mailing Address" />
                <div className={style.flexIt}>
                    <TextBlock field={city} label="City" />
                    <FieldBlock field={state} label="State">
                        <select className="form-select" {...domOnlyProps(state)} style={{ width: 'auto' }}>
                            <option value="">-- Select state --</option>
                            {states.map(usState => (
                                <option key={usState} value={usState}>
                                    {usState}
                                </option>
                            ))}
                        </select>
                    </FieldBlock>
                    <TextBlock field={zip} label="Zip Code" />
                </div>
            </div>
        );
    }
}

export const states = [
    'Alabama',
    'Alaska',
    'American Samoa',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
];
